import axios from 'axios'

const apiClient = axios.create({
    // create single axios instance for entire app
    baseURL: 'https://api.timify.com/v1', // base URL to call
    timeout: 20000,
    headers: {
        'Accept' : 'application/json',
        'Content-Type' : 'application/json',
    }
})

export default {
    getServices (calenderid) {
        return apiClient.get('/booker-services/companies', {
            params: {
                'company_id': calenderid,
            }
        })
    },
    getTimeSlots (date, calenderid, services) {
        return apiClient.get('/booker-services/availabilities', {
            params: {
                'company_id': calenderid,
                'service_id': services,
                'days[]': date
            }
        })
    },
    createReservation (calenderid, services, date, time) {
        return apiClient.post('/booker-services/reservations', {
            'company_id': calenderid,
            'service_id': services,
            'date': date,
            'time': time
        })
    },
    deleteReservation (calenderid, reservation_id, secret, reason) {
        let url = "https://api.timify.com/v1/booker-services/reservations/"+ reservation_id;
        return axios.delete(url, {
            headers: {
                'Accept' : 'application/json',
                'Content-Type' : 'application/json',
            },
            data: {
                'company_id': calenderid,
                'secret': secret,
                'reason':reason
            },
        })
    },
    postAppointement (calenderid, reservation_id, secret, fields) {
        return apiClient.post('/booker-services/appointments/confirm', {
            'reservation_id': reservation_id,
            'company_id': calenderid,
            'secret': secret,
            'fields': fields
        })
    }
}
